export default __webpack_public_path__ + "9fb0ceef9a1673a2690aad7eb0f3a197.png";